import React from "react";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
// import circularIcon from "../../assets/images/partnerDashboard/logo/circularIcon.png"
import BNRathiLogoSide from "../../assets/images/BNRathiLogoSide.png";
import { useLocation, useNavigate } from "react-router-dom";

import alert from "../../assets/images/alert.gif";
import { useDispatch } from "react-redux";
import usePersistStoreData from "../Hooks/usePersistStoreData";
import { logoutThunk, logoutUser } from "../../slices/thunks";
import { showToast } from "../ToastNotification";
import { useSelector } from "react-redux";
import { store } from "../../store";

const LogOutModal = ({ showModal, onCloseClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;

  const { logoutLoading } = useSelector((state) => state.Logout_user);

  const handleLogout = () => {
    dispatch(logoutThunk({ token }))
      .then((res) => {
        if (res?.payload?.code === 200) {
          showToast("Logged Out Successfully", "success");
          navigate("/login");
          store.dispatch(logoutUser());
        } else {
          showToast(
            res?.payload?.message || "Something went wrong, please try again",
            "error"
          );
        }
      })
      .catch((error) => {
        showToast(
          error?.message || "Something went wrong, please try again",
          "error"
        );
      });
  };

  return (
    <Modal isOpen={showModal} toggle={onCloseClick} centered={true}>
      {/* <ModalHeader toggle={onCloseClick}>Logout</ModalHeader> */}
      <ModalBody
        className=""
        style={{
          paddingTop: "0px",
          paddingBottom: "2rem",
        }}
      >
        <div className=" text-center">
          <img
            src={alert}
            alt=""
            style={{ width: 200, height: 200 }} // Adjust size as needed
          />
          <h3>Sign Out Confirmation</h3>
          <p className=" fs-14 fw-medium text-dark text-center">
            Are You Sure You Want To sign out ?
          </p>
        </div>

        <div className="d-flex gap-3 justify-content-center mt-4 mb-0">
          <button
            type="button"
            className="btn w-sm btn-muted border"
            data-bs-dismiss="modal"
            onClick={() => {
              onCloseClick();
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn w-sm btn-danger centerContent"
            data-bs-dismiss="modal"
            onClick={() => {
              handleLogout();
            }}
          >
            {logoutLoading ? <Spinner size="sm" /> : "Sign Out"}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LogOutModal;
